
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-golf_svg-a)","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12 15.99a7.75 7.75 0 100-15.5 7.75 7.75 0 000 15.5zm5 1.079a9.508 9.508 0 01-10 0m5 1.421v5.02"}}),_c('path',{attrs:{"d":"M15.5 4.76a.25.25 0 01.25.25m-.5 0a.25.25 0 01.25-.25m0 .5a.25.25 0 01-.25-.25m.5 0a.25.25 0 01-.25.25m1.5 3a.25.25 0 01.25.25m-.5 0a.25.25 0 01.25-.25m0 .5a.25.25 0 01-.25-.25m.5 0a.25.25 0 01-.25.25m-3.5 0a.25.25 0 01.25.25m-.5 0a.25.25 0 01.25-.25m0 .5a.25.25 0 01-.25-.25m.5 0a.25.25 0 01-.25.25m1.5 3a.25.25 0 01.25.25m-.5 0a.25.25 0 01.25-.25m0 .5a.25.25 0 01-.25-.25m.5 0a.25.25 0 01-.25.25m-4-.5a.25.25 0 01.25.25m-.5 0a.25.25 0 01.25-.25m0 .5a.25.25 0 01-.25-.25m.5 0a.25.25 0 01-.25.25"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-golf_svg-a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    